// Equal jitter spreads retries while retaining a bounded recovery delay.
export default function retryDelay(attempt, baseDelay = 1000) {
  return Math.round(
    Math.min(30000, baseDelay * 2 ** Math.min(attempt, 10)) *
      (0.5 + Math.random() / 2),
  );
}

export const waitForRetry = (delay, signal) => {
  if (signal?.aborted || delay <= 0) {
    return Promise.resolve();
  }

  return new Promise(resolve => {
    let timer;
    const finish = () => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', finish);
      resolve();
    };
    timer = setTimeout(finish, delay);
    signal?.addEventListener('abort', finish, { once: true });
  });
};
